import React from 'react';

export const SectionHeader = ({ eyebrow, title, subtitle }) => {
  return (
    <div style={{ width: '100%', textAlign: 'left', marginBottom: '22px', fontFamily: 'sans-serif' }}>
      {eyebrow && (
        <span
          style={{
            fontSize: '14px',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            color: 'var(--primary)',
            display: 'block',
            marginBottom: '8px',
            marginTop: '20px'
          }}
        >
          {eyebrow}
        </span>
      )}
      <h2
        style={{
          fontSize: '32px',
          fontWeight: '700',
          color: 'var(--text-primary)',
          margin: '0 0 12px 0',
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          style={{
            fontSize: '16px',
            lineHeight: '1.6',
            color: 'var(--text-secondary)',
            margin: '0',
            maxWidth: '720px',
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};
